module.exports = __webpack_public_path__ + "img/e26087b.png";